import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { ApiError } from 'features/common'
import { Box, styled } from '@mui/material'
import { IconButton, Typography, TypographyProps } from '@carto/meridian-ds/components'
import BackIcon from 'assets/icons/icon-navigation-arrow-back.svg?react'

const TitleWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}))

const Title = styled(Box)(() => ({
  display: 'flex',
  flex: '1',
  alignItems: 'center'
}))

const BackIconButton = styled(IconButton)(({ theme }) => ({
  marginRight: theme.spacing(1)
}))

interface BasicPageTitleProps {
  title?: ReactNode
  titleId?: string
  TypographyProps?: TypographyProps
  titleChildren?: ReactNode
  primaryAction?: ReactNode
  backUrl?: string
  hasError?: ApiError | null // TODO VVG: hasError is not boolean
}

function BasicPageTitle({
  title,
  titleId,
  titleChildren,
  primaryAction,
  backUrl,
  hasError,
  TypographyProps
}: BasicPageTitleProps) {
  const navigate = useNavigate()
  const hasTitle = title || titleId || titleChildren

  return (
    <TitleWrapper>
      {hasTitle && (
        <Title pt={3} pb={3} className="pageTitle">
          {backUrl && <BackIconButton onClick={() => navigate(backUrl)} icon={<BackIcon />} />}

          {(title || titleId) && (
            <Typography aria-label={titleId} variant="h5" {...(TypographyProps || {})}>
              {title ? title : <FormattedMessage id={titleId} />}
            </Typography>
          )}

          {titleChildren}
        </Title>
      )}
      {!hasError && primaryAction && <Box pl={3}>{primaryAction}</Box>}
    </TitleWrapper>
  )
}

export default BasicPageTitle
